import React, { useState } from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
// import useIsMobileResize from "../../../../hooks/useIsMobileResize"
import {
  BenefitsFlex,
  BenefitsRow,
  HeroContainerWrapper,
  HeroContainer,
  ButtonsContainer,
  BadgeContainer,
} from "./hero.styled"

import HeroMobile from "./hero.mobile"
import HeroDesktop from "./hero.desktop"
import Badge from "../badge/badge"

const Hero = ({ data }) => {
  const { buttons, benefits, heading, images } = data
  const [core, setCore] = useState("balance")
  const [newCore, setNewCore] = useState("balance")
  const [fadeState, setFadeState] = useState("fadeInOpacity")
  const [fadeNewState, setNewFadeState] = useState("fadeInOpacity")
  /*
   * FOUC issue with using useIsMobileResize to render HeroMobile vs HeroDesktop
   * const isMobile = useIsMobileResize(1279)
   */
  const TitleSection = (
    <>
      <Box maxWidth={[327, 327, 570, 688]} className={`mx-lg`}>
        <TextElementNova
          text={heading}
          element="h1"
          className="Title-30-Super-Normal text-center lg:text-left bg-filter"
        />
      </Box>
      <ButtonsContainer
        maxWidth={[327, 327, 570, 688]}
        className={`mx-lg bg-filter`}
        pt={[24, 24, 32, 40]}
        pb={[8]}
      >
        <Box>
          <ButtonNova
            icon={`Right`}
            trackObject={{
              destination: buttons.womenPcp.ctaLink,
              name: "Marketing CTA Clicked",
            }}
            {...buttons.womenPcp}
          />
        </Box>
        <Box>
          <ButtonNova
            icon={`Right`}
            trackObject={{
              destination: buttons.men.ctaLink,
              name: "Marketing CTA Clicked",
            }}
            {...buttons.men}
          />
        </Box>
      </ButtonsContainer>
    </>
  )

  const BenefitsSection = (
    <Box maxWidth={[327, 327, 527, 527, 800]} className={`mx-lg`}>
      <BenefitsFlex>
        {benefits[newCore].items.map((item, index) => (
          <BenefitsRow key={index}>
            <Box width={[1]}>
              <TextElementNova
                text={item}
                element="p"
                classes={{
                  default: "Body-20-Dia-Normal",
                  768: "Body-30-Dia-Normal",
                  1280: "Body-30-Dia-Normal",
                }}
              />
            </Box>
          </BenefitsRow>
        ))}
      </BenefitsFlex>

      <Box
        width={[133, 133, 125, 146]}
        pt={[32, 32, 40]}
        pb={[40, 40, 48, 48, 0]}
        className={`mx-lg`}
      >
        <ButtonNova
          icon={`Right`}
          label={`Shop Now`}
          trackObject={{
            destination: buttons[newCore].ctaLink,
            name: "Marketing CTA Clicked",
            module_name: "lifestage",
          }}
          className="lifestage-cta"
          ctaLink={buttons[newCore].ctaLink}
        />
      </Box>
    </Box>
  )

  const ImagesSectionFn = (imgRef) => {
    return (
      <Box
        mx="auto"
        className="image-wrapper bg-filter filter-three"
        ref={imgRef}
      >
        {Object.keys(images).map((key, index) => (
          <img
            style={{
              animation: getFadeState(key)
                ? `${getFadeState(key)} .5s ease-in-out forwards`
                : "none",
            }}
            key={index}
            src={images[key]}
            alt=""
            role={`presentation`}
          />
        ))}
      </Box>
    )
  }

  const setCoreFade = (newcore) => {
    if (newcore === core) return
    setFadeState("fadeOutOpacity")
    setTimeout(() => {
      setNewCore(newcore)
      setNewFadeState("fadeInOpacity")
      setTimeout(() => {
        setCore(newcore)
        setFadeState("fadeInOpacity")
      }, 150)
    }, 150)
  }

  const getFadeState = (key) =>
    core === key ? fadeState : newCore === key ? fadeNewState : null

  return (
    <HeroContainerWrapper className={`hero-container-wrapper`}>
      <HeroContainer>
        <BadgeContainer
          mt={[32, 32, 40]}
          mb={["6px", "6px", 14, 14, 0]}
          className={`badge-container text-center`}
        >
          <Badge />
        </BadgeContainer>
        <HeroMobile
          data={data}
          TitleSection={TitleSection}
          BenefitsSection={BenefitsSection}
          ImagesSectionFn={ImagesSectionFn}
          newCore={newCore}
          setCoreFade={setCoreFade}
        />
        <HeroDesktop
          data={data}
          TitleSection={TitleSection}
          BenefitsSection={BenefitsSection}
          ImagesSectionFn={ImagesSectionFn}
          newCore={newCore}
          setCoreFade={setCoreFade}
        />
      </HeroContainer>
    </HeroContainerWrapper>
  )
}

export default Hero
